function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Given the `FileReader.readAsDataURL()` based `dataURI` extracts that data into an actual Blob along with the name
 * of that Blob if provided in the URL. If no name is provided, then the name falls back to `unknown`.
 *
 * @param dataURI - The `DataUrl` potentially containing name and raw data to be converted to a Blob
 * @returns - an object containing a Blob and its name, extracted from the URI
 */
export default function dataURItoBlob(dataURILike) {
  var _a; // check if is dataURI


  if (dataURILike.indexOf('data:') === -1) {
    throw new Error('File is invalid: URI must be a dataURI');
  }

  var dataURI = dataURILike.slice(5); // split the dataURI into media and base64, with the base64 signature

  var splitted = dataURI.split(';base64,'); // if the base64 signature is not present, the latter part will become empty

  if (splitted.length !== 2) {
    throw new Error('File is invalid: dataURI must be base64');
  } // extract the mime type, media parameters including the name, and the base64 string


  var _splitted = _slicedToArray(splitted, 2),
      media = _splitted[0],
      base64 = _splitted[1];

  var _media$split = media.split(';'),
      _media$split2 = _toArray(_media$split),
      mime = _media$split2[0],
      mediaparams = _media$split2.slice(1);

  var type = mime || ''; // extract the name from the parameters

  var name = decodeURI( // parse the parameters into key-value pairs, find a key, and extract a value
  // if no key is found, then the name is unknown
  ((_a = mediaparams.map(function (param) {
    return param.split('=');
  }).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return key === 'name';
  })) === null || _a === void 0 ? void 0 : _a[1]) || 'unknown'); // Built the Uint8Array Blob parameter from the base64 string.

  try {
    var binary = atob(base64);
    var array = new Array(binary.length);

    for (var i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    } // Create the blob object


    var blob = new window.Blob([new Uint8Array(array)], {
      type: type
    });
    return {
      blob: blob,
      name: name
    };
  } catch (error) {
    throw new Error('File is invalid: ' + error.message);
  }
}